import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LiteYouTube from "../Common/LiteYoutube";

export default function ClientExperiences({ homeData, pageKey, tag }) {
  const [testimonials, setTestimonials] = useState([]);
  const [generalServicesData, setGeneralServicesData] = useState(null);
  const sliderRef = React.useRef(null);

  const getEmbedUrl = (url) => {
    if (typeof url !== "string" || !url.trim()) return "";

    const patterns = [
      /youtu(?:\.be|be\.com)\/(?:.*v=)?([^?&/]+)/i, // covers youtu.be/ID and youtube.com/watch?v=ID and other variants
      /youtube\.com\/embed\/([^?&/]+)/i,
    ];

    let id = null;
    for (const re of patterns) {
      const m = url.match(re);
      if (m && m[1]) {
        id = m[1];
        break;
      }
    }

    // If still no id, return the original url (best-effort)
    if (!id) return url;

    // Return canonical embed URL. Disable related videos and captions options as you had.
    return `https://www.youtube.com/embed/${id}?rel=0&controls=0&cc_load_policy=0`;
  };

    const getYouTubeId = (url = "") => {
    if (typeof url !== "string") return null;

    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&/]+)/,
    );
    return match?.[1] || null;
  };

  useEffect(() => {
    // Normalize testimonials into an array
    let t = [];
    if (
      homeData &&
      homeData.data &&
      homeData.data.data &&
      homeData.data.data?.[pageKey] &&
      homeData.data.data?.[pageKey]?.testimonial_info_data
    ) {
      t = homeData.data.data?.[pageKey]?.testimonial_info_data;
    } else if (Array.isArray(homeData)) {
      t = homeData;
    } else if (homeData && Array.isArray(homeData.testimonial_info_data)) {
      // defensive: some APIs return object with testimonial_info_data on root
      t = homeData.testimonial_info_data;
    } else if (homeData && homeData.data && Array.isArray(homeData.data)) {
      t = homeData.data;
    } else {
      t = [];
    }

    setTestimonials(t);

    // parse general settings safely
    if (
      homeData &&
      homeData.data &&
      homeData.data.data &&
      homeData.data.data.general_settings &&
      Array.isArray(homeData.data.data.general_settings.general_settings_data)
    ) {
      const general_setting_data =
        homeData.data.data.general_settings.general_settings_data;

      let service_display = null;
      general_setting_data.forEach((service_data_info) => {
        if (service_data_info.tag === `${tag}_testimonial`) {
          service_display = service_data_info;
        }
      });

      if (service_display) {
        try {
          const parsedData = JSON.parse(service_display.response);
          setGeneralServicesData(parsedData);
        } catch (e) {
          // fallback if response is already an object
          setGeneralServicesData(service_display.response || null);
        }
      } else {
        setGeneralServicesData(null);
      }
    } else {
      setGeneralServicesData(null);
    }
  }, [homeData, pageKey, tag]);

  var settings = {
    dots: false,
    arrow: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <div className="container">
        {Array.isArray(testimonials) && testimonials.length > 0 ? (
          <>
            {generalServicesData ? <h2>{generalServicesData?.title}</h2> : null}
            <div className="client-wrap">
              <Slider ref={sliderRef} {...settings}>
                {testimonials.map((testimonial, idx) => {
                  const key = testimonial?.id ?? testimonial?.video_id ?? idx;
                  const videoId = getYouTubeId(testimonial.video_url);
                  console.log("ID:", videoId);

                  const showVideo =
                    (pageKey === "home" || tag === "smart_city") && !!videoId;

                  return (
                    <div className="testimonial-sec" key={key}>
                      {showVideo ? (
                        <div className="slider-vid-section mt-4">
                          <div className="section-row">
                            <div className="vid-col">
                              <LiteYouTube
                                videoId={videoId}
                                videoUrl={getEmbedUrl(testimonial.video_url)}
                                onPlay={() => sliderRef.current?.slickPause()}
                                title={
                                  testimonial.video_title ||
                                  "Client testimonial"
                                }
                              />
                            </div>

                            <div className="text-col">
                              <h3 className="head-desc">
                                {testimonial.video_title}
                              </h3>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: testimonial.description || "",
                                }}
                              />
                              <a
                                className="button"
                                href={`https://www.youtube.com/watch?v=${videoId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Know more
                              </a>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="item">
                          <div className="img">
                            <figure>
                              <img
                                src={testimonial.image}
                                alt={
                                  testimonial.altText || testimonial.name || ""
                                }
                                height={269}
                                width={269}
                                loading="lazy"
                              />
                            </figure>
                          </div>

                          <div className="content">
                            <div className="content-inner">
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: testimonial.description || "",
                                }}
                              />
                              <span className="quote-ic" />
                            </div>
                            <div className="name">
                              <span>{testimonial.name}</span>
                              <span className="position">
                                {testimonial.role}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </Slider>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
}
